export default "__VITE_ASSET__CYkt3YOS__"